import Image from "next/image";
import { BlockProps } from "../BlocksManager/registry";

function renderMarkedTitle(title: string, highlightClass: string) {
    const parts = title.split(/(\[.*?\])/g);
    return parts.map((part, index) => {
        const isHighlighted = part.startsWith("[") && part.endsWith("]");
        if (isHighlighted) {
            const text = part.slice(1, -1);
            return (
                <span
                    key={index}
                    className={`inline-block font-heading  text-black ${highlightClass}`}
                >
                    {text}
                </span>
            );
        }

        return <span key={index}>{part}</span>;
    });
}


export default function BoissonsSection({ data }: BlockProps) {
    if (!data) return null;
    const items = data?.boissons || [];
    return (
        <section className="bg-white  py-16 container" key={data.id}>
            <div className="mx-auto max-w-[1400px]">
                <div className="mx-auto max-w-[900px] text-center">

                    <h2 className="font-display text-[26px] font-bold leading-tight text-text-body ">

                        {renderMarkedTitle(data.titre, "text-[45px] md:text-[60px]")}
                    </h2>
                </div>

                <div className="mt-14 flex flex-col items-center justify-center md:flex-row md:items-end">
                    {items.map((item: any, index: any)  => {
                        const bgClass = index % 2 === 0 ? "bg-yellow-light" : "bg-violet-light";

                        return (
                            <article
                                key={item.id}
                                className={[
                                    "relative flex h-[520px] w-full max-w-[330px] flex-col items-center rounded-[343px] px-8 pb-10 pt-10 text-center",
                                    bgClass,
                                    index > 0 ? "md:-ml-8" : "",
                                ].join(" ")}
                            >
                                {/* zone image fixe */}
                                <div className="relative  h-[250px] w-[180px] shrink-0 md:h-[280px] md:w-[200px]">
                                    <Image
                                        src={item.image.url}
                                        alt={item.imageAlt || item.nom}
                                        fill
                                        className="object-contain object-center"
                                    />
                                </div>

                                {/* zone titre fixe et centrée */}
                                <div className="mt-6 flex h-[150px] items-center  justify-center ">
                                    <h3 className="font-heading max-w-[250px] text-center font-medium text-[34px]  leading-[1.2] text-black md:text-[34px]">
                                        {item.nom}
                                    </h3>
                                </div>
                            </article>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}